export const COLLECTION_PAGE_CANONICALS = Object.freeze({
  '/collections/vlone-apparel': '/apparel/brand/vlone',
  '/collections/mcq': '/brand/mcq',
  '/collections/burberry-arthur-sneaker': '/sneakers/silhouette/burberry-arthur',
  '/collections/supreme': '/apparel/brand/supreme',
  '/collections/bape': '/apparel/brand/bape',
  '/collections/dior': '/sneakers/brand/dior',
  '/collections/chrome-hearts': '/apparel/brand/chrome-hearts',
  '/collections/new-in-from-alexander-mcqueen': '/brand/alexander-mcqueen',
  '/collections/new-off-white': '/apparel/brand/off-white',
  '/collections/air-jordan-2020-2021': '/sneakers/brand/air-jordan',
  '/collections/comme-des-garcons-sneakers': '/brand/comme-des-garcons',
  '/collections/travis-scott-bb79679b-ecc4-4ad8-a7ab-107bb548afbe': '/brand/travis-scott',
  '/collections/gucci': '/brand/gucci',
  '/collections/dior-apparel': '/apparel/brand/dior',
  '/collections/clot': '/brand/clot',
  '/collections/raf-simons': '/sneakers/brand/raf-simons',
  '/collections/acne-studios-apparel': '/apparel/brand/acne-studios',
  '/collections/palm-angels-apparel': '/brand/palm-angels',
  '/collections/rhude': '/brand/rhude',
  '/collections/trending-essentials': '/apparel/brand/fear-of-god-essentials',
  '/collections/palace': '/apparel/brand/palace',
  '/collections/bottega-veneta': '/brand/bottega-veneta',
  '/collections/pleasures-apparel': '/apparel/brand/pleasures',
  '/collections/stussy-collection': '/apparel/brand/stussy',
  '/collections/kith': '/brand/kith',
  '/collections/aries': '/apparel/brand/aries',
  '/collections/rick-owens': '/brand/rick-owens',
  '/collections/balenciaga-apparel': '/apparel/brand/balenciaga',
  '/collections/chinatown-market-apparel': '/apparel/brand/chinatown-market',
  '/collections/cdg-cb52cd5d-e7d7-492d-89bd-ba17a36a31e9': '/brand/comme-des-garcons',
  '/collections/cactus-plant-flea-market': '/brand/cactus-plant-flea-market',
  '/collections/off-white-apparel-accessories': '/sneakers/brand/off-white',
  '/collections/mm6-maison-margiela': '/apparel/brand/mm6-maison-margiela',
  '/collections/kidsuper': '/brand/kidsuper',
  '/collections/vans': '/brand/vans',
  '/collections/anti-social-social-club': '/apparel/brand/anti-social-social-club',
  '/collections/air-jordan-since-1985': '/sneakers/brand/air-jordan',
  '/collections/aj7-since-1992': '/sneakers/silhouette/air-jordan-7',
  '/collections/nike-dunk': '/sneakers/silhouette/dunk',
  '/collections/alexander-mcqueen': '/sneakers/brand/alexander-mcqueen',
  '/collections/amq': '/brand/alexander-mcqueen',
  '/collections/air-jordan-4': '/sneakers/silhouette/air-jordan-4',
  '/collections/af1': '/sneakers/silhouette/air-force-1',
  '/collections/nike-sb': '/sneakers/silhouette/dunk-sb',
  '/collections/air-jordan-3': '/sneakers/silhouette/air-jordan-3',
  '/collections/air-max-1': '/sneakers/silhouette/air-max-1',
  '/collections/new-balance-2020': '/sneakers/brand/new-balance',
  '/collections/fear-of-god-655fa0ae-f249-45b8-9a8e-3b09d0b9aacb': '/brand/fear-of-god',
  '/collections/air-jordan-11': '/sneakers/silhouette/air-jordan-11',
  '/collections/margiela-apparel': '/apparel/brand/maison-margiela',
});
